/** Mirrors TravelFuture API's shared base DTOs — see migration guide Bölüm 4.1. */

/** Confirmed empirically against the real API (ServiceError.message does NOT exist). */
export interface ServiceErrorFlags {
  authenticationError?: boolean;
  authorizationError?: boolean;
  inputFormatError?: boolean;
  inputLogicError?: boolean;
  unknownError?: boolean;
  systemError?: boolean;
  bookingProviderError?: boolean;
  databaseError?: boolean;
  paymentGateError?: boolean;
}

export interface ServiceError {
  errorMessages?: string[];
  errorFlags?: ServiceErrorFlags;
}

export interface ResponseBase {
  hasError: boolean;
  serviceError?: ServiceError | null;
}

export interface SessionHeader {
  sessionId: string;
  sessionToken: string;
}

export type Currency = 'TRY' | 'USD' | 'EUR' | 'GBP' | 'CHF' | 'KZT';

export type ProviderType =
  | 'Air'
  | 'Hotel'
  | 'Transfer'
  | 'Coper'
  | 'Bus'
  | 'RentCar'
  | 'Tour'
  | 'Insurance';

export type BookingStatus =
  | 'Allocated'
  | 'PassengersUpdated'
  | 'StagedBooking'
  | 'Prebooked'
  | 'Booked'
  | 'Finalized'
  | 'Cancelled'
  | 'Exchange'
  | 'Open'
  | 'PaymentAccepted'
  | 'Offered';

export type UserType = 'B2C' | 'B2E' | 'GSA' | 'SYSTEM' | 'SP';

export type ApprovalStatus = 'Approved' | 'Pending' | 'Denied';

export interface PricingBase {
  baseFare?: number;
  totalTax?: number;
  totalMarkupFare?: number;
  totalServiceFee?: number;
  totalExtraFee?: number;
  totalFare?: number;
  currency?: Currency | null;
  agencyMargin?: number;
  totalFareTRY?: number;
}

export interface Passenger {
  firstName?: string;
  lastName?: string;
  paxType?: string;
  gender?: string;
  birthDate?: string;
  email?: string;
  phone?: string;
  citizenNo?: string;
  passportNo?: string;
  passportExpireDate?: string;
  nationality?: string;
  hesCode?: string;
  frequentFlayerNo?: string;
  paxReferanceId?: string;
  isChild?: boolean;
  /** Bus-only extras (`Bus/UpdatePassengers`). */
  selectedShuttle?: string;
  wheelChairService?: number;
}

export interface Contact {
  name?: string;
  lastName?: string;
  phone?: string;
  email?: string;
}

/** Thrown by the api client for hasError:true responses — kept distinct from HTTP/network failures. */
export class ApiError extends Error {
  serviceError?: ServiceError | null;

  constructor(message: string, serviceError?: ServiceError | null) {
    super(message);
    this.name = 'ApiError';
    this.serviceError = serviceError;
  }
}
